import { WpImage } from '@streamamg/wordpress-lib';
import { ImageSize } from './image.component';
import { ThumbnailFlavors } from '@streamamg/stream-play-lib';

export class ImageUtils {

  public static getWpSrcSet(image: WpImage): ImageSize[] | string | null {

    if (!image) {
      return null;
    }

    if (image.subtype === 'webp' || image.subtype === 'svg+xml') {
      return image.url;
    }

    return [{
      url: image.url,
      width: image.width,
      //  height: image.height,
    }].concat(Object.values(image.sizes));
  }

  public static getCmSrcSet(url: string, sizes: number[]): ImageSize[] {

    const srcSet: ImageSize[] = [];

    if (url && sizes?.length > 0) {
      sizes.forEach((size) => {

        srcSet.push({
          url: `${url}width/${size}?day=${new Date().getDate()}`,
          width: size,
        });
      });
    }

    return srcSet;
  }


  public static getSpSrcSet(image: ThumbnailFlavors): ImageSize[] {
    const srcSet: ImageSize[] = [];

    if (image) {

      const picture = {...image};
      delete picture.source;

      Object.keys(picture).forEach((size) => {

        if (picture[size] && picture[size] !== '') {
          srcSet.push({
            url: picture[size],
            width: parseInt(size, 10),
          });
        }

      });
    }

    return srcSet;
  }
}
